import { render, staticRenderFns } from "./GeneralList.vue?vue&type=template&id=7c203846&scoped=true"
import script from "./GeneralList.vue?vue&type=script&lang=js"
export * from "./GeneralList.vue?vue&type=script&lang=js"
import style0 from "./GeneralList.vue?vue&type=style&index=0&id=7c203846&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c203846",
  null
  
)

export default component.exports